import React from "react";
import API from "../../Api/Api";
import endpoints from "../../Api/Endpoints";
import { showAlert } from "../../feedback/feedbackApi";

export async function downloadProviderDocument(providerType, providerId, type, defaultFilename) {
  if (!providerId || !type) return;

  const isDoctor = String(providerType || "").toLowerCase() === "doctor";

  try {
    if (isDoctor) {
      const res = await API.get(endpoints.adminDoctorDownloadDocument(providerId, type), {
        responseType: "blob",
      });
      const blob = res?.data;
      if (!blob || !(blob instanceof Blob)) throw new Error("No file");

      const cd = res?.headers?.["content-disposition"] || res?.headers?.["Content-Disposition"] || "";
      let filename = `${defaultFilename || type}.pdf`;
      const quoted = /filename="([^"]+)"/i.exec(cd);
      const plain = /filename=([^;\s]+)/i.exec(cd);
      if (quoted?.[1]) filename = quoted[1].trim();
      else if (plain?.[1]) {
        try {
          filename = decodeURIComponent(plain[1].replace(/["']/g, "").trim());
        } catch {
          filename = plain[1].replace(/["']/g, "").trim();
        }
      }

      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      a.click();
      URL.revokeObjectURL(url);
      return;
    }

    throw new Error("Hospital download is not supported from this button.");
  } catch (err) {
    console.error(err);
    showAlert(err?.response?.data?.message || err?.message || "Download failed.", {
      variant: "error",
      title: "Download failed",
    });
  }
}

export function getDocumentKind(url) {
  const value = String(url || "").toLowerCase();
  if (!value) return "unknown";
  if (value.includes(".pdf")) return "pdf";
  if (
    value.includes(".png") ||
    value.includes(".jpg") ||
    value.includes(".jpeg") ||
    value.includes(".webp") ||
    value.includes(".gif")
  ) {
    return "image";
  }
  return "unknown";
}

export function DocumentPreview({ url, title, compact = false }) {
  const kind = getDocumentKind(url);

  if (!url) return null;

  const frameHeight = compact ? 200 : 420;

  if (kind === "pdf") {
    return (
      <iframe
        src={url}
        title={title}
        className={`doc_preview${compact ? " doc_preview--compact" : ""}`}
        style={{
          width: "100%",
          height: `${frameHeight}px`,
          border: "1px solid #e5e7eb",
          borderRadius: compact ? "10px" : "14px",
          background: "#fff",
        }}
      />
    );
  }

  if (kind === "image") {
    return (
      <img
        src={url}
        alt={title}
        className={`doc_preview${compact ? " doc_preview--compact" : ""}`}
        style={
          compact
            ? {
                display: "block",
                width: "100%",
                maxHeight: 200,
                objectFit: "contain",
                border: "1px solid #e5e7eb",
                borderRadius: "10px",
                background: "#fff",
              }
            : undefined
        }
      />
    );
  }

  return (
    <div
      className="doc_preview"
      style={{
        minHeight: "160px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        border: "1px solid #e5e7eb",
        borderRadius: "14px",
        background: "#fff",
        padding: "16px",
        textAlign: "center",
      }}
    >
      <a href={url} target="_blank" rel="noopener noreferrer">
        Open document
      </a>
    </div>
  );
}
